import React, { useState } from 'react';
import { database, ref, set } from './firebase'; // Adjust the path as needed

const SoftwareRequirements = () => {
  const [projectName, setProjectName] = useState('');
  const [requirements, setRequirements] = useState('');
  const [softwareType, setSoftwareType] = useState('');
  const [databaseType, setDatabaseType] = useState('');
  const [targetAudience, setTargetAudience] = useState('');
  const [keyFeatures, setKeyFeatures] = useState('');
  const [budget, setBudget] = useState('');
  const [timeline, setTimeline] = useState('');
  const [teamSize, setTeamSize] = useState('');
  const [developmentDetails, setDevelopmentDetails] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const softwareOptions = [
    'Web Application',
    'Mobile Application',
    'Desktop Application',
    'API Development',
    'Other'
  ];

  const databaseOptions = [
    'MySQL',
    'PostgreSQL',
    'MongoDB',
    'SQLite',
    'Firebase Realtime Database',
    'Other'
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!projectName || !requirements || !softwareType || !databaseType) {
      setError('Please fill in all required fields');
      return;
    }

    const requirementsData = {
      projectName,
      requirements,
      softwareType,
      databaseType,
      targetAudience,
      keyFeatures,
      budget,
      timeline,
      teamSize,
      developmentDetails,
      timestamp: Date.now(),
    };

    try {
      // Save to Firebase Realtime Database
      await set(ref(database, 'softwareRequirements/' + Date.now()), requirementsData);
      setSuccess('Requirements submitted successfully!');
      // Clear all input fields after submission
      clearRequirementsForm();
    } catch (err) {
      setError('Failed to submit requirements: ' + err.message);
    }
  };

  const clearRequirementsForm = () => {
    setProjectName('');
    setRequirements('');
    setSoftwareType('');
    setDatabaseType('');
    setTargetAudience('');
    setKeyFeatures('');
    setBudget('');
    setTimeline('');
    setTeamSize('');
    setDevelopmentDetails('');
    setError('');
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Submit Software Requirements</h2>
      {error && <p style={styles.error}>{error}</p>}
      {success && <p style={styles.success}>{success}</p>}
      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="text"
          placeholder="Project Name"
          value={projectName}
          onChange={(e) => setProjectName(e.target.value)}
          style={styles.input}
          required
        />
        <textarea
          placeholder="Enter your requirements"
          value={requirements}
          onChange={(e) => setRequirements(e.target.value)}
          style={styles.input}
          required
        />
        <select
          value={softwareType}
          onChange={(e) => setSoftwareType(e.target.value)}
          style={styles.input}
          required
        >
          <option value="" disabled>Select Software Type</option>
          {softwareOptions.map((option, index) => (
            <option key={index} value={option}>{option}</option>
          ))}
        </select>
        <select
          value={databaseType}
          onChange={(e) => setDatabaseType(e.target.value)}
          style={styles.input}
          required
        >
          <option value="" disabled>Select Database Type</option>
          {databaseOptions.map((option, index) => (
            <option key={index} value={option}>{option}</option>
          ))}
        </select>
        <input
          type="text"
          placeholder="Target Audience"
          value={targetAudience}
          onChange={(e) => setTargetAudience(e.target.value)}
          style={styles.input}
        />
        <textarea
          placeholder="Key Features"
          value={keyFeatures}
          onChange={(e) => setKeyFeatures(e.target.value)}
          style={styles.input}
        />
        <input
          type="text"
          placeholder="Budget"
          value={budget}
          onChange={(e) => setBudget(e.target.value)}
          style={styles.input}
        />
        <input
          type="text"
          placeholder="Timeline"
          value={timeline}
          onChange={(e) => setTimeline(e.target.value)}
          style={styles.input}
        />
        <input
          type="text"
          placeholder="Team Size"
          value={teamSize}
          onChange={(e) => setTeamSize(e.target.value)}
          style={styles.input}
        />
        <textarea
          placeholder="Additional Development Details (if any)"
          value={developmentDetails}
          onChange={(e) => setDevelopmentDetails(e.target.value)}
          style={styles.input}
        />
        <button type="submit" style={styles.button}>Submit</button>
      </form>

      {/* Footer */}
      <footer style={styles.footer}>
        <p style={styles.footerText}>© 2024 Butterflywings Software Company Pvt Ltd. All rights reserved.</p>
      </footer>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: 'black',
    color: '#00FFFF',
    padding: '20px',
    borderRadius: '8px',
  },
  title: {
    marginBottom: '20px',
    fontSize: '2rem',
  },
  error: {
    color: 'red',
  },
  success: {
    color: 'green',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '400px',
  },
  input: {
    padding: '10px',
    margin: '5px',
    borderRadius: '5px',
    border: '1px solid #00FFFF',
    width: '100%',
    backgroundColor: 'white',
    color: 'black',
    boxSizing: 'border-box', // Ensure padding is included in width
  },
  button: {
    backgroundColor: '#00FFFF',
    color: 'black',
    border: 'none',
    padding: '10px 20px',
    margin: '10px 0',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: 'transform 0.3s, box-shadow 0.3s',
  },
  footer: {
    backgroundColor: 'black',
    color: '#00FFFF',
    textAlign: 'center',
    padding: '10px 0',
    position: 'relative',
    bottom: 0,
    width: '100%',
    marginTop: '20px', // Add some space above the footer
  },
  footerText: {
    margin: 0,
  },
};

export default SoftwareRequirements;
